export var TABLE_CELL_LABEL_CLASS_PREFIX = 'TableCellLabel';
export var tableCellLabelRootTestId = 'TableCellLabelRoot';